<template>
  <div class="text-nowrap">
    <div
      v-for="(item, index) in currentActions"
      :key="index"
      class="d-inline-block mx-2"
    >
      <a
        v-if="item === 'view' && certificate"
        :href="certificate"
        target="_blank"
        class="icon icon-eye"
        aria-label=""
      ></a>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'HabilitationAction',
  props: ['habilitation'],
  computed: {
    ...mapFields(['user']),
    certificate() {
      return this.$lodash.get(this.habilitation, 'certificate', false) || false;
    },
    currentActions() {
      if(this.certificate)
        return ['view'];
      else
        return [];
    }
  },
};
</script>

<style scoped></style>
